"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableHeader = void 0;
const classnames_1 = __importDefault(require("classnames"));
const React = __importStar(require("react"));
const CheckboxWithoutLabel_1 = __importDefault(require("../Checkboxes/CheckboxWithoutLabel"));
const TableHeader = ({ headers, sortedHeaderId, sortDirection }) => {
    return (React.createElement("thead", null,
        React.createElement("tr", null, headers.map((header) => {
            if (header.type === 'checkbox') {
                return (React.createElement("th", { key: header.id, style: { width: 16 } },
                    React.createElement(CheckboxWithoutLabel_1.default, { checked: header.checked, onChange: header.onChange, id: header.id, indeterminate: header.indeterminate, disabled: header.disabled })));
            }
            else {
                const headerClassNames = classnames_1.default({
                    info: header.infoHeader,
                    sort: header.sortFunction,
                });
                return (React.createElement("th", { className: headerClassNames, onClick: header.sortFunction, key: header.id, style: header.width || header.textAlign ? getStyle(header) : undefined },
                    header.name,
                    sortedHeaderId === header.id &&
                        (sortDirection === 'desc' ? (React.createElement("span", { className: "aio-icon aio-icon-arrow_down" }, "\u00A0")) : (React.createElement("span", { className: "aio-icon aio-icon-arrow_up" }, "\u00A0")))));
            }
        }))));
    function getStyle(header) {
        return {
            textAlign: header.textAlign,
            width: header.width,
        };
    }
};
exports.TableHeader = TableHeader;
//# sourceMappingURL=TableHeader.js.map